import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import BuildIcon from '@mui/icons-material/Build';
import CodeIcon from '@mui/icons-material/Code';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import styled from 'styled-components';
import { useTheme } from '@emotion/react';
import { Circle } from '../StyledComponents';







function TechHighlights() 
{
  return (
    <Box my={5}>
        <Grid 
            spacing={5}
            container 
            direction="row" 
            sx={{
                justifyContent:"center"
            }}
        >
            <Grid item xs={12} sm={6} md={4}  sx={{display:'flex',flexDirection:"column",alignItems:"center",gap:"20px"}}>
                <Circle data-aos="fade-up" data-aos-duration="2000">
                    <BuildIcon 
                        sx={{
                            fontSize:"3rem"
                        }}
                    />
                </Circle>
                <Typography variant='h4' sx={{textAlign:"center"}} data-aos="fade-up" data-aos-duration="2000">
                    Scalable Solutions
                </Typography>
                <Typography variant='h6' sx={{color:'shade.light',textAlign:"center"}} data-aos="fade-up" data-aos-duration="2000">
                    I build responsive and scalable web applications tailored to provide seamless user experiences across all devices and platforms.
                </Typography>
                
            </Grid>
            <Grid item xs={12} sm={6} md={4} sx={{display:'flex',flexDirection:"column",alignItems:"center",gap:'20px'}}>
                <Circle data-aos="fade-up" data-aos-duration="2000">
                    <CodeIcon 
                        sx={{
                            fontSize:"3rem"
                        }}
                    />
                </Circle>
                <Typography variant='h4' sx={{color:"text.primary",textAlign:"center"}} data-aos="fade-up" data-aos-duration="2000">
                    Clean and Efficient Code
                </Typography>
                <Typography variant='h6' sx={{color:'shade.light',textAlign:"center"}} data-aos="fade-up" data-aos-duration="2000">
                    I focus on writing efficient, maintainable, and well-documented code, ensuring high performance and reliability.
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} sx={{display:'flex',flexDirection:"column",alignItems:"center",gap:"20px"}}>
                <Circle data-aos="fade-up" data-aos-duration="2000">
                    <LightbulbIcon 
                        sx={{
                            fontSize:"3rem"
                        }}
                    />
                </Circle>
                <Typography variant='h4' sx={{color:'text.primary',textAlign:"center"}} data-aos="fade-up" data-aos-duration="2000">
                    Innovative Ideas
                </Typography>
                <Typography variant='h6' sx={{color:'shade.light',textAlign:"center"}} data-aos="fade-up" data-aos-duration="2000">
                    I bring creativity and innovation to every project, developing user-centric features that push the boundaries of web applications.
                </Typography>
            </Grid>
        </Grid>
    </Box>
  )
}

export default TechHighlights